import { render, staticRenderFns } from "./demoTabs.vue?vue&type=template&id=04166d6b&"
import script from "./demoTabs.vue?vue&type=script&lang=js&"
export * from "./demoTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports